module.exports = __webpack_public_path__ + "media/assets/images/shopping/frozen-fc87ede955e5bc8d92973d380028e16f.svg";